import { render, staticRenderFns } from "./EditTableCanvas.vue?vue&type=template&id=3544949b&scoped=true&"
import script from "./EditTableCanvas.vue?vue&type=script&lang=js&"
export * from "./EditTableCanvas.vue?vue&type=script&lang=js&"
import style0 from "./EditTableCanvas.vue?vue&type=style&index=0&id=3544949b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3544949b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\web\\V-LAB\\project\\bayes-vue2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3544949b')) {
      api.createRecord('3544949b', component.options)
    } else {
      api.reload('3544949b', component.options)
    }
    module.hot.accept("./EditTableCanvas.vue?vue&type=template&id=3544949b&scoped=true&", function () {
      api.rerender('3544949b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/table/EditTableCanvas.vue"
export default component.exports